import React from 'react';

import { Messages } from '../../../../../gen-src/Localize';
import {
  FlowDownstreamWorkbooksQueryVariables, FlowDownstreamWorkbooksQuery, WorkbooksDisplayGridRowDataFragment, FlowDownstreamWorkbooksFilteredByFlowOutputFieldQueryVariables, FlowDownstreamWorkbooksFilteredByFlowOutputFieldQuery, WorkbookSortOrder,
  FlowDownstreamWorkbooksFilteredByFlowOutputFieldDocument,
  FlowDownstreamWorkbooksDocument
} from '../../../../../gen-src/queries';
import {
  ConnectionListResult,
  GridSortProps,
  PaginatedQueryWrapper
} from '../../../data-catalog-shared';
import { getRowDataForWorkbook, WorkbooksDisplayGrid, WorkbooksDisplayGridRowData } from '../sharedDisplayGrid/WorkbooksDisplayGrid';
import { WorkbooksValidSortFields } from '../sorting/sortProviders/WorkbooksGridSortProvider';

type QueryVariables = FlowDownstreamWorkbooksQueryVariables;
type QueryResults = FlowDownstreamWorkbooksQuery;
type QueryResultListNode = WorkbooksDisplayGridRowDataFragment;
type GridRowData = WorkbooksDisplayGridRowData;

type QueryVariablesWithFilter = FlowDownstreamWorkbooksFilteredByFlowOutputFieldQueryVariables;
type QueryResultsWithFilter = FlowDownstreamWorkbooksFilteredByFlowOutputFieldQuery;
type QueryResultListNodeWithFilter = WorkbooksDisplayGridRowDataFragment;


function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  const flow = resultData && resultData.flows && resultData.flows[0];
  return flow ? flow.downstreamWorkbooksConnection : null;
}

function selectConnectionListResultForFilteredQuery(
  resultData: QueryResultsWithFilter
): ConnectionListResult<QueryResultListNodeWithFilter> | null {
  const flow = resultData && resultData.flows && resultData.flows[0];
  const flowOutputFields = flow && flow.outputFieldsConnection && flow.outputFieldsConnection.nodes;
  const field = flowOutputFields && flowOutputFields[0];
  return field ? field.downstreamWorkbooksConnection : null;
}

export type FlowDownstreamWorkbooksQueryGridProps =
  GridSortProps<WorkbooksValidSortFields> & {
    readonly flowVizportalUrlId: string;
    readonly filteredFlowOutputFieldId: string | null;
    readonly rowCount: number | null;
  };

export function FlowDownstreamWorkbooksQueryGrid(props: FlowDownstreamWorkbooksQueryGridProps): JSX.Element {
  const emptyGridMessage = Messages.EmptyDownstreamWorkbooksLineageGridMessage();
  const emptyFilteredGridMessage = Messages.EmptyDownstreamFilteredWorkbooksLineageGridMessage();

  return (
    props.filteredFlowOutputFieldId ? (
      <PaginatedQueryWrapper<QueryVariablesWithFilter, QueryResultsWithFilter, QueryResultListNodeWithFilter, GridRowData>
        queryGql={FlowDownstreamWorkbooksFilteredByFlowOutputFieldDocument}
        partialQueryVariables={{
          flowVizportalUrlId: props.flowVizportalUrlId,
          selectedFlowOutputFieldId: props.filteredFlowOutputFieldId,
          orderBy: props.orderBy as WorkbookSortOrder,
        }}
        selectConnectionListResult={selectConnectionListResultForFilteredQuery}
        mapResultNode={getRowDataForWorkbook}
      >
        {({ rowStore }) => <WorkbooksDisplayGrid
          rowStore={rowStore}
          emptyGridMessage={emptyFilteredGridMessage}
          rowCount={props.rowCount}
          orderBy={props.orderBy}
          updateSortOrder={props.updateSortOrder}
        />}
      </PaginatedQueryWrapper>
    ) : (
      <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
        queryGql={FlowDownstreamWorkbooksDocument}
        partialQueryVariables={{
          flowVizportalUrlId: props.flowVizportalUrlId,
          orderBy: props.orderBy as WorkbookSortOrder,
        }}
        selectConnectionListResult={selectConnectionListResult}
        mapResultNode={getRowDataForWorkbook}
      >
        {({ rowStore }) => <WorkbooksDisplayGrid
          rowStore={rowStore}
          emptyGridMessage={emptyGridMessage}
          rowCount={props.rowCount}
          orderBy={props.orderBy}
          updateSortOrder={props.updateSortOrder}
        />}
      </PaginatedQueryWrapper>
    )
  )
}
